import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import {
  getBenificiary,
  editBenificiary,
} from "../../store/actions/benificiarys_action";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import Spinner from "../../components/layout/Spinner";
import AddForm from "../../components/common/AddForm";
import { upload } from "../../shared/upload";
import {
  initialValues,
  inputFields,
} from "../../shared/enums/benificiarys_enum";

const EditBenificiary = ({
  editBenificiary,
  getBenificiary,
  match,
  benificiary: { loading, benificiary },
}) => {
  let history = useHistory();
  useEffect(() => {
    getBenificiary(match.params.id);
  }, [match]);
  const [featuredImage, setFeaturedImage] = useState(null);
  const [gallery, setGallery] = useState(null);
  const submitBenificiary = async (values) => {
    if (featuredImage || gallery) {
      const images = await upload(featuredImage, gallery);
      if (images) {
        if (images.featured_image) {
          values.featured_image = images.featured_image;
        }
        if (images.gallery_images) {
          values.gallery = images.gallery_images;
        }
      }
    }
    await editBenificiary(benificiary.id, values);
    history.push(`/benificiarys/${benificiary.id}/view`);
  };

  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title="Edit Benificiary"
          mainLinkTitle="Benificiarys"
          mainLinkUrl="/benificiarys"
          activeLink="Edit"
        />
      </div>
      <div className="container-fluid">
        <div className="col-lg-12">
          <div className="card">
            {!loading ? (
              benificiary && (
                <div>
                  <div className="card-header">
                    <div>
                      <h4 className="card-title">
                        {benificiary.title} - <span>Edit</span>{" "}
                      </h4>
                      <p className="card-title-desc">
                        <Link to="/benificiarys" className="btn btn-soft-light">
                          <i className="fa fa-angle-left"></i> Benificiarys
                        </Link>
                        <Link
                          to={`/benificiarys/${benificiary.id}/view`}
                          className="btn btn-soft-light"
                        >
                          <i className="fa fa-eye"></i>
                        </Link>
                      </p>
                    </div>
                  </div>
                  <AddForm
                    data={benificiary}
                    edit={true}
                    featuredImage={featuredImage}
                    gallery={gallery}
                    setFeaturedImage={setFeaturedImage}
                    setGallery={setGallery}
                    submitForm={submitBenificiary}
                    inputFields={inputFields}
                    initialValues={initialValues}
                  />
                </div>
              )
            ) : (
              <div className="text-center">
                <Spinner />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  alert: state.alert,
  benificiary: state.benificiary,
});

const mapDispatchToProps = { editBenificiary, getBenificiary };

export default connect(mapStateToProps, mapDispatchToProps)(EditBenificiary);
